import(/* webpackMode: "eager" */ "/home/forge/www.medkart.in/releases/82082909/app/isr/[locale]/[device]/[...slug]/error.tsx");
